/** Whether the browser user-agent is a mobile device.  */
export const isMobile = /Mobi|Tablet|iPad|iPhone|Android/.test(navigator.userAgent);

/** Whether the browser user-agent is a desktop.  */
export const isDesktop = !isMobile;
